import { wikiUrl } from '../../lib/wikiUrl';

/** Resolve a registry wiki slug to an external href, or omit when unset (PRO-0480). */
export function placeholderWikiHref(wikiPath: string | undefined): string | undefined {
  if (!wikiPath) {
    return undefined;
  }
  const href = wikiUrl(wikiPath);
  return href || undefined;
}
